<circ-loader [isLoading]="loading">
  <h2>{{ 'circ_reorderSteps_title' | i18n}}</h2>
  <p>{{ 'REORDER_STEPS_CIRCULATION_DUEDATE' | i18n }} {{(circulation$ | async)?.props.dueDate | i18nDate:{ date: "medium" } }}</p>
  <kendo-grid [data]="steps"
    (edit)="editHandler($event)"
    (cancel)="cancelHandler($event)"
    (save)="saveHandler($event)">
          <!-- mobile view -->
          <kendo-grid-column [title]="'circ_reorderSteps_title' | i18n" media="(max-width: 571px)">
            <ng-template kendoGridCellTemplate let-x>
              <div class="d-flex flex-row justify-content-between ">
                <div class="d-flex flex-column flex-1" >
                  <div class="d-flex flex-row align-center">
                    <span>{{'grid_title' | i18n}}: {{x.payload.data.title}}</span>
                  </div>
                  <div class="d-flex flex-row align-center"> {{'grid_dueDate' | i18n}}: {{x.dueDate| i18nDate: { date: "medium" } }}
                    <ng-template kendoGridEditTemplate
                    let-dataItem="dataItem"
                    let-formGroup="formGroup">
                    <kendo-datepicker *ngIf="dataItem.dueDate" [title]="'grid_dueDate' | i18n" [formControl]="formGroup.get('dueDate')" [min]="minDueDate"></kendo-datepicker>
                    <kendo-numerictextbox [title]="'grid_sortOrder' | i18n"
                      [formControl]="formGroup.get('order')"
                      [min]="1"
                      [max]="steps.length">
                    </kendo-numerictextbox>
                  </ng-template>
                  </div>
                  <div class="d-flex flex-row align-center"> {{'grid_sortOrder' | i18n}}:  {{x.order}}
                  </div>
                  <div class="order-error">
                    <span *ngIf="x.validOrder?.before">{{ 'step_new_formerror_dueDate_before_range' | i18n:x.validOrder }}</span>
                    <span *ngIf="x.validOrder?.after">{{ 'step_new_formerror_dueDate_after_range' | i18n:x.validOrder }}</span>
                  </div>
                </div>
              </div>
              <div class="order-error">
                <span *ngIf="x.validOrder?.before">{{ 'step_new_formerror_dueDate_before_range' | i18n:x.validOrder }}</span>
                <span *ngIf="x.validOrder?.after">{{ 'step_new_formerror_dueDate_after_range' | i18n:x.validOrder }}</span>
              </div>
            </ng-template>
          </kendo-grid-column>

         <!-- desktop view -->
    <kendo-grid-column [title]="'grid_title' | i18n" media="(min-width: 571px)">
      <ng-template kendoGridCellTemplate let-x>
        <span class="nobr">{{ x.payload.data.title }}</span>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column [title]="'grid_dueDate' | i18n" media="(min-width: 571px)"
      field="dueDate">
      <ng-template kendoGridEditTemplate
        let-dataItem="dataItem"
        let-formGroup="formGroup">
        <kendo-datepicker *ngIf="dataItem.dueDate" [title]="'grid_dueDate' | i18n" [formControl]="formGroup.get('dueDate')" [min]="minDueDate"></kendo-datepicker>
      </ng-template>
      <ng-template kendoGridCellTemplate let-x>
        <span class="nobr">{{ x.dueDate | i18nDate:{ date: "medium" } }}</span>
        <div class="order-error">
          <span *ngIf="x.validOrder?.before">{{ 'step_new_formerror_dueDate_before_range' | i18n:x.validOrder }}</span>
          <span *ngIf="x.validOrder?.after">{{ 'step_new_formerror_dueDate_after_range' | i18n:x.validOrder }}</span>
        </div>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="order" [title]="'grid_sortOrder' | i18n" media="(min-width: 571px)">
      <ng-template kendoGridEditTemplate
        let-dataItem="dataItem"
        let-formGroup="formGroup">
        <kendo-numerictextbox [title]="'grid_sortOrder' | i18n"
          [formControl]="formGroup.get('order')"
          [min]="1"
          [max]="steps.length">
        </kendo-numerictextbox>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-messages [noRecords]="'kendo_noRecords' | i18n">
    </kendo-grid-messages>
    <kendo-grid-command-column [width]="150">
      <ng-template kendoGridCellTemplate>
          <!-- edit command directive, will be visible when not in edit mode -->
          <button kendoGridEditCommand [primary]="true" [title]="'circ_reorderSteps_button_edit' | i18n" >{{'circ_reorderSteps_button_edit' | i18n}}</button>
          <!-- save command directive, will be visible when in edit mode -->
          <button kendoGridSaveCommand [title]="'circ_reorderSteps_button_editOk' | i18n" >{{'circ_reorderSteps_button_editOk' | i18n}}</button>
          <!-- cancel command directive, will be visible when in edit mode -->
          <button kendoGridCancelCommand [title]="'circ_reorderSteps_button_editAbort' |i18n" >{{ 'circ_reorderSteps_button_editAbort' |i18n }}</button>
      </ng-template>
   </kendo-grid-command-column>
  </kendo-grid>
  <div class="k-form-buttons">
    <ece-btn-primary [disabled]="hasErrors" (click)="save()" [text]=" 'step_new_button_save' | i18n "></ece-btn-primary>
    <ece-btn (click)="abort()" [text]=" 'step_new_button_abort' | i18n "></ece-btn>
  </div>
</circ-loader>
